import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createTheme } from '@atlaskit/theme/components';
import { codeFontFamily, fontFamily, fontSize, gridSize } from '@atlaskit/theme/constants';
import * as componentTokens from './component-tokens';
var disabledRules = {
  light: {
    backgroundColor: componentTokens.defaultBackgroundColor.light,
    backgroundColorFocus: componentTokens.disabledBackgroundColor.light,
    backgroundColorHover: componentTokens.disabledBackgroundColor.light,
    borderColor: componentTokens.defaultBackgroundColor.light,
    // same as bg, appears as no border
    borderColorFocus: componentTokens.defaultBorderColorFocus.light,
    textColor: componentTokens.disabledTextColor.light
  },
  dark: {
    backgroundColor: componentTokens.defaultBackgroundColor.dark,
    backgroundColorFocus: componentTokens.disabledBackgroundColor.dark,
    backgroundColorHover: componentTokens.disabledBackgroundColor.dark,
    borderColor: componentTokens.defaultBackgroundColor.dark,
    // same as bg, appears as no border
    borderColorFocus: componentTokens.defaultBorderColorFocus.dark,
    textColor: componentTokens.disabledTextColor.dark
  }
};
var invalidRules = {
  light: {
    backgroundColor: componentTokens.defaultBackgroundColor.light,
    backgroundColorFocus: componentTokens.defaultBackgroundColorFocus.light,
    backgroundColorHover: componentTokens.defaultBackgroundColorHover.light,
    borderColor: componentTokens.invalidBorderColor.light,
    borderColorFocus: componentTokens.defaultBorderColorFocus.light
  },
  dark: {
    backgroundColor: componentTokens.defaultBackgroundColor.dark,
    backgroundColorFocus: componentTokens.defaultBackgroundColorFocus.dark,
    backgroundColorHover: componentTokens.defaultBackgroundColorHover.dark,
    borderColor: componentTokens.invalidBorderColor.dark,
    borderColorFocus: componentTokens.defaultBorderColorFocus.dark
  }
};
var backgroundColor = {
  standard: componentTokens.defaultBackgroundColor,
  subtle: componentTokens.transparent,
  none: componentTokens.transparent
};
var backgroundColorFocus = {
  standard: componentTokens.defaultBackgroundColorFocus,
  subtle: componentTokens.defaultBackgroundColorFocus,
  none: componentTokens.transparent
};
var backgroundColorHover = {
  standard: componentTokens.defaultBackgroundColorHover,
  subtle: componentTokens.defaultBackgroundColorHover,
  none: componentTokens.transparent
};
var borderColor = {
  standard: componentTokens.defaultBorderColor,
  subtle: componentTokens.transparent,
  none: componentTokens.transparent
};
var borderColorFocus = {
  standard: componentTokens.defaultBorderColorFocus,
  subtle: componentTokens.defaultBorderColorFocus,
  none: componentTokens.transparent
};

var getContainerBackgroundColor = function getContainerBackgroundColor(_ref) {
  var appearance = _ref.appearance,
      isFocused = _ref.isFocused,
      isHovered = _ref.isHovered,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      mode = _ref.mode;

  if (isDisabled) {
    // switch on focus then switch on hover
    if (isFocused) {
      return {
        backgroundColor: disabledRules[mode].backgroundColorFocus
      };
    }

    if (isHovered) {
      return {
        backgroundColor: disabledRules[mode].backgroundColorHover
      };
    }

    return {
      backgroundColor: disabledRules[mode].backgroundColor
    };
  }

  if (isInvalid) {
    // switch on focus then switch on hover
    if (isFocused) {
      return {
        backgroundColor: invalidRules[mode].backgroundColorFocus
      };
    }

    if (isHovered) {
      return {
        backgroundColor: invalidRules[mode].backgroundColorHover
      };
    }

    return {
      backgroundColor: invalidRules[mode].backgroundColor
    };
  } // switch on appearance then focus then switch on hover


  if (isFocused) {
    return {
      backgroundColor: backgroundColorFocus[appearance][mode]
    };
  }

  if (isHovered) {
    return {
      backgroundColor: backgroundColorHover[appearance][mode]
    };
  }

  return {
    backgroundColor: backgroundColor[appearance][mode]
  };
};

var getContainerBorderColor = function getContainerBorderColor(_ref2) {
  var appearance = _ref2.appearance,
      isFocused = _ref2.isFocused,
      isDisabled = _ref2.isDisabled,
      isInvalid = _ref2.isInvalid,
      mode = _ref2.mode;

  if (isDisabled) {
    // switch on focus then switch on hover
    if (isFocused) {
      return {
        borderColor: disabledRules[mode].borderColorFocus
      };
    }

    return {
      borderColor: disabledRules[mode].borderColor
    };
  }

  if (isInvalid) {
    // switch on focus then switch on hover
    if (isFocused) {
      return {
        borderColor: invalidRules[mode].borderColorFocus
      };
    }

    return {
      borderColor: invalidRules[mode].borderColor
    };
  } // switch on appearance then focus then switch on hover


  if (isFocused) {
    return {
      borderColor: borderColorFocus[appearance][mode]
    };
  }

  return {
    borderColor: borderColor[appearance][mode]
  };
};

var getPlaceholderColor = function getPlaceholderColor(_ref3) {
  var isDisabled = _ref3.isDisabled,
      mode = _ref3.mode;
  return isDisabled ? disabledRules[mode].textColor : componentTokens.placeholderTextColor[mode];
};

var getMaxWidth = function getMaxWidth(_ref4) {
  var width = _ref4.width;

  if (!width) {
    return "100%";
  }

  switch (width) {
    case 'xsmall':
      return '80px';

    case 'small':
      return '160px';

    case 'medium':
      return '240px';

    case 'large':
      return '320px';

    case 'xlarge':
      return '480px';

    default:
      return "".concat(width, "px");
  }
};

export var Theme = createTheme(function (props) {
  return {
    container: _objectSpread(_objectSpread(_objectSpread({
      alignItems: 'center'
    }, getContainerBackgroundColor(props)), getContainerBorderColor(props)), {}, {
      borderRadius: '3px',
      borderWidth: '2px',
      borderStyle: props.appearance === 'none' ? 'none' : 'solid',
      boxSizing: 'border-box',
      color: props.isDisabled ? disabledRules[props.mode].textColor : componentTokens.textColor[props.mode],
      cursor: props.isDisabled ? 'not-allowed' : 'text',
      display: 'flex',
      flex: '1 1 100%',
      fontSize: "".concat(fontSize(), "px"),
      justifyContent: 'space-between',
      maxWidth: getMaxWidth(props),
      overflow: 'hidden',
      transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
      wordWrap: 'break-word',
      verticalAlign: 'top',
      pointerEvents: 'auto'
    }),
    input: {
      backgroundColor: 'transparent',
      border: 0,
      boxSizing: 'border-box',
      color: 'inherit',
      cursor: 'inherit',
      fontFamily: props.isMonospaced ? codeFontFamily() : fontFamily(),
      fontSize: "".concat(fontSize(), "px"),
      minWidth: '0',
      outline: 'none',
      padding: "".concat(props.isCompact ? gridSize() / 2 : gridSize(), "px ").concat(gridSize() - 2, "px"),
      width: '100%',
      height: "".concat((props.isCompact ? gridSize() * 3.5 : gridSize() * 4.5) / fontSize(), "em"),
      lineHeight: gridSize() * 2.5 / fontSize(),
      '&[disabled]': {
        // Safari puts on some difficult to remove styles, mainly for disabled inputs
        // but we want full control so need to override them in all cases
        WebkitTextFillColor: 'unset',
        WebkitOpacity: 1
      },
      // Hide the clear indicator on Edge (Windows only)
      '&::-ms-clear': {
        display: 'none'
      },
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::placeholder': {
        color: getPlaceholderColor(props)
      }
    }
  };
});
export var themeTokens = {
  backgroundColor: backgroundColor,
  backgroundColorFocus: backgroundColorFocus,
  backgroundColorHover: backgroundColorHover,
  borderColor: borderColor,
  borderColorFocus: borderColorFocus,
  placeholderTextColor: componentTokens.placeholderTextColor,
  textColor: componentTokens.textColor,
  invalidRules: invalidRules,
  disabledRules: disabledRules
};